import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { ITEM_MODE_NO, SITE_INPUT_MODE } from '../../Constants';

/**
 * 道路幅設定ダイアログ
 * 敷地の寸法クリックで表示される
 */
class RoadSetting extends Dialog {
  _targetSite: marietta.webcad.item.Site;

  get targetSite(): marietta.webcad.item.Site {
    return this._targetSite;
  }

  set targetSite(value: marietta.webcad.item.Site) {
    this._targetSite = value;

    // 道路幅の取得
    (<HTMLInputElement>document.getElementById('input_roadWidthText')).value = String(this.targetSite.itemInfo.dotList[this.index].road_w);
    if ((this.targetSite.itemInfo.dotList[this.index].road_w) === 0) {
      (<HTMLInputElement>document.getElementById('input_roadWidthText')).value = '4000';
    }
  }

  index: number;

  initDone: boolean = false; // 初期化完了

  inputElement: HTMLInputElement;

  MIN_ROAD_WIDTH: number = 1000;

  MAX_ROAD_WIDTH: number = 10000;

  /**
   * コンストラクタ
   */
  constructor(draggable: boolean) {
    super(draggable);
    this.initDone = false;

    // ダイアログのコンテンツ生成
    const id: string = 'roadSettingDialog';
    let title: string = '道路の作成';

    // タイトル
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'en': title = 'Create Road'; break;
      default: title = '道路の作成'; break;
    }

    let contents: string = '<div class="dialogRoomTextSetting">\n';
    contents += '<table>\n';
    contents += '<tbody>\n';
    contents += '<tr>\n';
    contents += '<td><span class="jp">道路幅：</span><span class="en">Road Width:</span><input type="number"  id="input_roadWidthText" min="0" max="10000" style="width:120px"> mm</td>\n';
    contents += '</tr>\n';
    contents += '<tr>\n';
    contents += '<td><p class="notationMessage"><span class="jp">※1,000mmに満たない道路は削除されます。</span><span class="en">*Roads that are 1000mm and smaller will be removed.</span></p></td>\n';
    contents += '</tr>\n';
    contents += '</tbody>\n';
    contents += '</table>\n';
    contents += '</div>';
    let footer: string = '<button id="btnDoneRoadSetting"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
    footer += '<button id="btnClose"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';
    this.createDialog(id, title, contents, footer);
    (<HTMLInputElement>document.getElementById('input_roadWidthText')).focus();
    // イベント設定
    const btn: HTMLElement = document.querySelector('#btnDoneRoadSetting');
    btn.addEventListener('click', this.updateRoadWidth);

    const self = this;
    const input = document.getElementById('input_roadWidthText');
    input.addEventListener('keyup', (event) => {
      if (event.keyCode === 13) {
        event.preventDefault();

        let val = parseFloat(self.inputElement.value);
        if (val < self.MIN_ROAD_WIDTH) {
          val = 0;
        } else if (val > self.MAX_ROAD_WIDTH) {
          val = self.MAX_ROAD_WIDTH;
        }
        self.inputElement.value = val.toString();
        self.updateRoadWidth();
      }
    });

    this.inputElement = (<HTMLInputElement>document.getElementById('input_roadWidthText'));
    this.inputElement.addEventListener('blur', self.restrictInputValue);
    document.getElementById('btnClose').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.removeDialog();
    });
  }

  /**
   * 数値の入力を制限
   */
  restrictInputValue = () => {
    let val = parseFloat(this.inputElement.value);
    if (val < this.MIN_ROAD_WIDTH) {
      val = 0;
    } else if (val > this.MAX_ROAD_WIDTH) {
      val = this.MAX_ROAD_WIDTH;
    }
    this.inputElement.value = val.toString();
  }

  /**
   * 名前設定の反映
   */
  updateRoadWidth = () => {
    // 幅
    const roadWidth = parseInt(this.inputElement.value, 10);

    // 幅の変更
    const resetLR: boolean = this.targetSite.itemInfo.dotList[this.index].road_w === 0;
    this.targetSite.itemInfo.dotList[this.index].road_w = roadWidth;
    // LRの計算
    if (resetLR) {
      // 座標が時計回りか、反時計回りか判定してLR判断
      if (!marietta.webcad.util.WebCADUtil.isClockwise(this.targetSite.itemInfo.dotList)) {
        this.targetSite.itemInfo.dotList[this.index].road_lr = true;
      }
    }
    // 描画し直し

    if (this.targetSite.inputMode === SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE) {
      const tarLayer: marietta.webcad.layer.SiteLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(1, ITEM_MODE_NO.MODE_SITE_NO) as marietta.webcad.layer.SiteLayer;
      const items = tarLayer.getAllChildren();
      for (let i = 0; i < items.length; i += 1) {
        (items[i] as marietta.webcad.item.Site).reCreateImage();
      }
    } else {
      this.targetSite.reCreateImage();
    }

    // 履歴
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

    // ダイアログを閉じる
    this.close();
  }
}

export default RoadSetting;
